// @ts-nocheck
import store from "common/Store";
import { hashFineractPublicAuthorizationAction } from "common/StoreActions";
import {
  FineractHttp,
  PublicHttp,
  SequestHttp,
  FineractEDRHttp,
  ImpairmentHttp,
} from "./Http";
import { EnvKeys } from "constants/EnvKeys";

ImpairmentHttp.interceptors.request.use((config) => {
  // eslint-disable-next-line
  const { authUser, fineractPublicAuthorizationHash } = store.getState().global;
  // eslint-disable-next-line
  const { base64EncodedAuthenticationKey, tfaToken } = authUser || {};
  return config;
});

ImpairmentHttp.interceptors.response.use(
  (response) => {
    storeHashing(response);
    return response;
  },
  (error) => {
    console.error({ error });
    if (error.response.status === 401) {
      store.dispatch(logoutAction());
    }
    return Promise.reject(error);
  }
);

FineractHttp.interceptors.request.use((config) => {
  const { authUser, fineractPublicAuthorizationHash } = store.getState().global;
  const { base64EncodedAuthenticationKey, tfaToken } = authUser || {};

  if (config.public) {
    passHashing(config, fineractPublicAuthorizationHash);
  }

  if (base64EncodedAuthenticationKey) {
    config.headers.Authorization = `Basic ${base64EncodedAuthenticationKey}`;

    if (tfaToken?.token) {
      config.headers["Fineract-Platform-TFA-Token"] = tfaToken.token;
    }
  }

  return config;
});

FineractHttp.interceptors.response.use(
  (response) => {
    storeHashing(response);
    return response;
  },
  (error) => {
    // console.log("FineractHttp", error?.message, error.toJSON());
    // if (error?.response?.status === 401 || error.message === "Network Error") {
    console.error({ error });
    if (error?.response?.status === 401) {
      store.dispatch(logoutAction());
    }
    return Promise.reject(error);
  }
);

SequestHttp.interceptors.request.use((config) => {
  const { sequest } = store.getState().global.authUser || {};

  if (sequest?.token) {
    // console.log(`Sequest Token`,sequest?.token);
    config.headers.Authorization = `Bearer ${sequest?.token}`;
  }

  return config;
});

FineractEDRHttp.interceptors.request.use((config) => {
  const { authUser, fineractPublicAuthorizationHash } = store.getState().global;
  const { base64EncodedAuthenticationKey, tfaToken } = authUser || {};

  if (config.public) {
    passHashing(config, fineractPublicAuthorizationHash);
  }

  if (base64EncodedAuthenticationKey) {
    config.headers.Authorization = `Basic ${base64EncodedAuthenticationKey}`;

    if (tfaToken?.token) {
      config.headers["Fineract-Platform-TFA-Token"] = tfaToken.token;
    }
  }

  return config;
});

FineractEDRHttp.interceptors.response.use(
  (response) => {
    storeHashing(response);
    return response;
  },
  (error) => {
    // console.log("FineractHttp", error?.message, error.toJSON());
    // if (error?.response?.status === 401 || error.message === "Network Error") {
    console.error({ error });
    if (error?.response?.status === 401) {
      store.dispatch(logoutAction());
    }
    return Promise.reject(error);
  }
);

SequestHttp.interceptors.request.use((config) => {
  const { sequest } = store.getState().global.authUser || {};

  if (sequest?.token) {
    // console.log(`Sequest Token`,sequest?.token);
    config.headers.Authorization = `Bearer ${sequest?.token}`;
  }

  return config;
});

SequestHttp.interceptors.response.use(undefined, (error) => {
  console.error({ error });
  if (error.response.status === 401) {
    // store.dispatch(logoutAction());
  }
  return Promise.reject(error);
});

PublicHttp.interceptors.request.use(async (config) => {
  const { authUser, fineractPublicAuthorizationHash } = store.getState().global;
  const { base64EncodedAuthenticationKey, tfaToken } = authUser || {};

  if (!config.headers.Authorization) {
    if (base64EncodedAuthenticationKey) {
      config.headers.Authorization = `Basic ${base64EncodedAuthenticationKey}`;
      if (tfaToken?.token) {
        config.headers["Fineract-Platform-TFA-Token"] = tfaToken.token;
      }
    }
  }

  if (
    config.headers.Authorization?.includes(EnvKeys.FINERACT_PUBLIC_API_KEY) ||
    !config.headers.Authorization
  ) {
    passHashing(config, fineractPublicAuthorizationHash);
  }

  return config;
});

PublicHttp.interceptors.response.use(
  (response) => {
    storeHashing(response);
    return response;
  },
  (error) => {
    console.error({ error });
    if (error?.response?.status === 401) {
      store.dispatch(logoutAction());
    }
    store.dispatch(publicApi.util.invalidateTags([{ type: RtkqTagEnum.USER }]));
    return Promise.reject(error);
  }
);

function passHashing(config, fineractPublicAuthorizationHash) {
  config.headers.Authorization = `${EnvKeys.FINERACT_PUBLIC_API_SCHEME} ${EnvKeys.FINERACT_PUBLIC_API_KEY}`;
  if (fineractPublicAuthorizationHash) {
    config.headers["Request-Nonce"] = fineractPublicAuthorizationHash;
  }
  return config;
}

function storeHashing(response) {
  const processId =
    response.headers["Response-Context"] || response.data?.processId;
  if (processId) {
    store.dispatch(hashFineractPublicAuthorizationAction({ processId }));
  }
  return response;
}
